/*
 * @Author: Dong
 * @Date: 2022-04-07 13:22:58
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-12-16 10:55:59
 */
import React, { createRef, forwardRef, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Select, Form } from 'sup-ui';
import FormList from './Form';

import messages from './messages';
import styles from './index.less';
import { FormComponentProps } from 'sup-ui/lib/form';

interface PropsType extends FormComponentProps {
  img: string;
  name: string;
  title: string;
  subTitle?: string;
  disabledTip?: string;
  status?: string;
  disabled: boolean;
  formData?: { name: string; label: string; type: any; rules?: any[] }[];
  percent?: any;
  initialValues: { [x: string]: any };
  selectedVersion: any;
  options: any;
  changeSelect: any;
  isRequired: boolean;
  isOptional: any;
  optionDetail: string;
}

const { Option } = Select;

const Package = forwardRef<FormComponentProps, PropsType>((props) => {
  const {
    name,
    img,
    title,
    subTitle,
    selectedVersion,
    options,
    formData,
    initialValues,
    changeSelect,
    form,
    isRequired,
    isOptional,
    optionDetail,
  } = props;

  const intl = useIntl();
  const formRef = createRef<FormComponentProps>();
  const i18nTitle = title && typeof title === 'object' ? intl.formatMessage(title) : title;
  const i18nSubTitle = subTitle && typeof subTitle === 'object' ? intl.formatMessage(subTitle) : subTitle;
  const { getFieldDecorator } = form;

  // 收集上传列表中的必填版本的选择
  useEffect(() => {
    if (!window.extForms) {
      window.extForms = {};
    }
    window.extForms[name] = form;
    return () => {
      delete window.extForms[name];
    };
  }, []);

  const handleChange = (value: string) => {
    if (!changeSelect) return;
    changeSelect(value, name);
  };

  return (
    <div style={{ position: 'relative' }} className={styles.container}>
      <div className={styles.content}>
        <div className={styles.info}>
          <img className={styles.img} src={img} alt="" />
          <div className={styles.infoTitle}>
            <p className={styles.title} title={i18nTitle}>
              {i18nTitle}
            </p>
            <p className={styles.subTitle} title={i18nSubTitle}>
              {i18nSubTitle}
            </p>
          </div>
        </div>
        {isOptional ? (
          <div className={styles.form}>
            <Form labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
              <Form.Item label={intl.formatMessage(messages.version)}>
                {getFieldDecorator('version', {
                  initialValue: selectedVersion,
                  rules: [
                    {
                      required: isRequired,
                      message: intl.formatMessage(messages.requiredNull),
                    },
                  ],
                })(
                  <Select allowClear placeholder={intl.formatMessage(messages.select)} onChange={handleChange}>
                    {(options || []).map((item: any) => {
                      const { archiveId, isAvailable, version } = item;

                      return (
                        <Option key={archiveId} value={archiveId} disabled={!isAvailable}>
                          {version}
                        </Option>
                      );
                    })}
                  </Select>,
                )}
              </Form.Item>
            </Form>
          </div>
        ) : (
          <span className={styles.disabled}>{optionDetail}</span>
        )}
      </div>
      {isOptional && formData && formData.length !== 0 ? (
        <FormList name={name} wrappedComponentRef={formRef} dataSource={formData} initialValues={initialValues} />
      ) : null}
    </div>
  );
});

export default Form.create()(Package);
